import { Model } from '@vuex-orm/core'
import Outdoor from "./Outdoor"
import Town from "./Town"
import Building from "./Building"
import Dungeon from "./Dungeon"


export default class Grid extends Model {
  static entity = 'grids'

  static fields () {
    return {
      id: this.attr(null),
      outdoors: this.hasMany(Outdoor, 'grid_id'),
      towns: this.hasMany(Town, 'grid_id'),
      buildings: this.hasMany(Building, 'grid_id'),
      dungeons: this.hasMany(Dungeon, 'grid_id')
    }
  }

  get areas () {
    return [].concat.apply([], [this.outdoors,  this.towns, this.dungeons, this.buildings])
  }

  get quests () {
    return [].concat.apply([], this.areas.map(area => area.quests))
  }

  get bosses () {
    return [].concat.apply([], this.areas.map(area => area.bosses))
  }

  get secrets () {
    return [].concat.apply([], this.areas.map(area => area.secrets))
  }

  get tomes () {
    return [].concat.apply([], this.areas.map(area => area.tomes))
  }
}